// ENV constants
export const VITEC_ENV = window.VITEC.ENV

export const LOGIN_URL = window.VITEC.LOGIN_PAGE
let apiPrefix = ''
let authPrefix = '/auth'
if (process.env.NODE_ENV !== 'development') {
  apiPrefix = `${window.VITEC.MDG}/auth2.5/public/index.php`
  authPrefix = window.VITEC.AUTH_API
}
export const API_PREFIX = apiPrefix
export const AUTH_PREFIX = authPrefix
export const MAIN_CONTROL_URL = `${window.VITEC.MDG}/navigation/`
// export const PERSONAL_CENTER_URL = `${window.VITEC.MDG}/mdg-personal-center/`
export const PERSONAL_CENTER_URL = `${MAIN_CONTROL_URL}?redirect_url=${encodeURIComponent(`${window.VITEC.MDG}/mdg-personal-center/`)}`


// Wechat
let officialAccountUrl = ''
let appId = ''
if (window.location.hostname === 'mdgf.vkforest.com') {
  // 备用正式服 mdgf
  officialAccountUrl = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU1OTMwNTc3OA==&scene=126&bizpsid=0#wechat_redirect'
  appId = 'wxd2b643969745015f'
} else if (VITEC_ENV === 'production') {
  // 正式服 mdg
  officialAccountUrl = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzI2NTYzMjQ3MQ==&scene=126&bizpsid=0#wechat_redirect'
  appId = 'wx7d031abe75ff68a7'
} else if (VITEC_ENV === 'test') {
  // 测试服 mdga
  officialAccountUrl = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzUxNzQ4OTA5Nw==&scene=126&bizpsid=0#wechat_redirect'
  appId = 'wx3118ad6ad5e1fdf0'
} else if (VITEC_ENV === 'demo') {
  // Demo 服 mdgc
  // officialAccountUrl = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU1OTMwNTc3OA==&scene=126&bizpsid=0#wechat_redirect'
  // appId = 'wxd2b643969745015f'
} else {
  // 研发服 mdgt
  officialAccountUrl = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzU5NTE3MTE0NQ==&scene=126&bizpsid=0#wechat_redirect'
  appId = 'wxb99a61b05a2fdf73'
}
export const OFFICIAL_ACCOUNT_URL = officialAccountUrl
export const WECHAT_APPID = appId
export const WECHAT_JSSDK_URL = `${window.VITEC.MDG}/jssdk/public/index.php`
export const WECHAT_LOGIN_URL = `${window.VITEC.MDG}/auth2.5/public/index.php/api/v1.Register/isRegisteredByUnionID`
export const WECHAT_REGISTER_URL = `${window.VITEC.MDG}/mdg-auth-wx/#/register`

// vuex global
export const SET_USER_INFO = 'SET_USER_INFO'

// Permission
// export const PERMISSION_SYSTEM = 403
